import React, { useState, useEffect } from "react";
import SideBarNav from "../sideBar/sideBarNav";
import Loading from "../Loading";
import MainBody from "./mainBody";
import HeaderBar from "../header/headerBar";
import FooterBar from "../footer/footerBar";
import MainFooter from "./mainFooter";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

interface Props {
  children: object;
  noHeader?: boolean;
  firstPage?: boolean;
  title?: string;
  btnBack?: boolean;
}
const Layout: React.FC<Props> = ({
  children,
  noHeader = false,
  firstPage = false,
  btnBack = false,
  title = "",
}) => {
  const { user, loader } = useSelector((state: any) => state);
  console.log(useSelector((state: any) => state))
  const history = useHistory();

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value: boolean) => {
    setToggled(value);
  };


  useEffect(() => {
    if (loader.isFetchedUser) {
    }
  }, [loader.isFetchedUser]);

  return (
    <>
      {!loader.isFetchedUser ? (
        <>
          <Loading />
        </>
      ) : (
        <>
        <HeaderBar></HeaderBar>
          <div className={`app ${toggled ? "toggled" : ""}`}>
            <MainBody
              title={title}
              noHeader={noHeader}
              firstPage={firstPage}
              btnBack={btnBack}
              handleToggleSidebar={handleToggleSidebar}
            >
              {children}

            </MainBody>
          </div>
          <FooterBar></FooterBar>
        </>
      )}
    </>
  );
};

export default Layout;
